import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export default function MoversMarquee({ gainers = [], losers = [], active = [] }) {
  const merged = [
    ...gainers.map((m) => ({ ...m, tag: "GAIN" })),
    ...active.map((m) => ({ ...m, tag: "VOL" })),
    ...losers.map((m) => ({ ...m, tag: "LOSS" })),
  ].filter((m) => m.ticker);

  if (merged.length === 0) {
    return (
      <div
        className="border-y border-white/10 bg-[#0A0A0C] py-2.5 px-6"
        data-testid="movers-marquee-empty"
      >
        <span className="font-mono text-xs tracking-[0.2em] text-zinc-500 uppercase">
          ── Awaiting market data ──
        </span>
      </div>
    );
  }

  // Duplicate items to allow seamless scroll loop
  const loop = [...merged, ...merged];

  return (
    <div
      className="relative border-y border-white/10 bg-[#0A0A0C] py-2.5 overflow-hidden marquee-pause"
      data-testid="movers-marquee"
    >
      <div className="marquee-track">
        {loop.map((m, i) => {
          const pct = parseFloat(String(m.change_percentage || "0").replace("%", ""));
          const isUp = pct >= 0;
          const color = isUp ? "text-green-400" : "text-red-400";
          return (
            <div
              key={`${m.ticker}-${i}`}
              className="flex items-center gap-2 px-6 border-r border-white/5"
            >
              <span className="font-mono text-[10px] tracking-[0.2em] text-zinc-500 uppercase">
                {m.tag}
              </span>
              <span className="font-mono font-bold text-white text-sm">{m.ticker}</span>
              <span className="font-mono text-zinc-400 text-sm">
                ${parseFloat(m.price || 0).toFixed(2)}
              </span>
              <span className={`font-mono text-sm flex items-center gap-0.5 ${color}`}>
                {isUp ? (
                  <ArrowUpRight className="w-3 h-3" strokeWidth={2.4} />
                ) : (
                  <ArrowDownRight className="w-3 h-3" strokeWidth={2.4} />
                )}
                {isUp ? "+" : ""}
                {pct.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
